/** Opens the official carrier tracker only when the customer submits a number. */
if (!customElements.get('mon-guest-tracking')) {
  customElements.define('mon-guest-tracking', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      const form = this.querySelector('form');
      if (!form) return;
      this.bound = true;
      const input = form.querySelector('[name="trknbr"]');
      const error = form.querySelector('[role="alert"]');
      const carrierOptions = form.querySelector('details');
      form.noValidate = true;
      carrierOptions.hidden = false;
      const clearError = () => {
        input.removeAttribute('aria-invalid');
        error.hidden = true;
        error.textContent = '';
      };
      input.addEventListener('input', clearError);
      form.addEventListener('change', clearError);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        clearError();
        const number = input.value.trim().replace(/[\s-]/g, '').toUpperCase();
        const fail = (message) => {
          error.textContent = message;
          error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        };
        if (!number) return fail('Saisissez votre numéro de colis.');
        if (/^#/.test(number) || /^[0-9]{1,6}$/.test(number)) {
          return fail('Utilisez le numéro de colis de votre email d’expédition, plutôt que le numéro de commande.');
        }
        if (!/^[A-Z0-9]{7,34}$/.test(number)) {
          return fail('Vérifiez votre numéro de colis : il doit contenir uniquement des lettres et des chiffres.');
        }
        let carrier = form.querySelector('[name="carrier"]:checked').value;
        if (carrier === 'auto') {
          if (/^1Z[A-Z0-9]{16}$/.test(number)) carrier = 'ups';
          else if (/^[0-9]{12,15}$/.test(number)) carrier = 'fedex';
          else {
            carrierOptions.open = true;
            error.textContent = 'Choisissez le transporteur indiqué dans votre email d’expédition.';
            error.hidden = false;
            form.querySelector('[name="carrier"][value="fedex"]').focus();
            return;
          }
        }
        const destination = carrier === 'ups'
          ? new URL('https://www.ups.com/track')
          : new URL('https://www.fedex.com/wtrk/track/');
        destination.searchParams.set(carrier === 'ups' ? 'tracknum' : 'trknbr', number);
        if (carrier === 'ups') destination.searchParams.set('loc', 'fr_FR');
        window.location.assign(destination.href);
      });
    }
  });
}
